module.exports = "https://static.wanderu.com/ui-react/_next/static/media/gb.601fdab6.svg";